<template lang="html">
  <div class="home-page">
    <home-hero></home-hero>
    <tour-value></tour-value>
    <brand-trust></brand-trust>
    <value-proposition></value-proposition>
    <proprietary-ems></proprietary-ems>
    <ems></ems>
    <case-studies></case-studies>
    <pmg-story></pmg-story>
    <contact></contact>
    <main-footer></main-footer>
  </div>
</template>

<script>
  import HomeHero from '@/components/HomeHero'
  import TourValue from '@/components/TourValue'
  import BrandTrust from '@/components/BrandTrust'
  import ValueProposition from '@/components/ValueProposition'
  import ProprietaryEms from '@/components/ProprietaryEms'
  import Ems from '@/components/Ems'
  import CaseStudies from '@/components/CaseStudies'
  import PmgStory from '@/components/PmgStory'
  import Contact from '@/components/Contact'
  import Footer from '@/components/Footer'

  export default {
    components: {
      'home-hero': HomeHero,
      'tour-value': TourValue,
      'brand-trust': BrandTrust,
      'value-proposition': ValueProposition,
      'proprietary-ems': ProprietaryEms,
      'ems': Ems,
      'case-studies': CaseStudies,
      'pmg-story': PmgStory,
      'contact': Contact,
      'main-footer': Footer
    },
    name: 'home',
    data () {
      return {
        data: {}
      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .home-page {
    max-width: 120rem;
    margin: 0 auto;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue